export const webTestRoutes = [
  {
    path: '/webTest/PackSimulation',
    name: 'WebTestPackSimulation',
    component: () => import(/* webpackChunkName: "webTest" */'@/views/webTest/PackSimulation.vue'),
    meta: {
      title: '打包模擬'
    }
  },
]
